<template>
    <div class="group card-element mx-3">
        <div class="row">
            <div class="col-sm-12 p-0">
                <div 
                    class="form-group" 
                    :class="[
                        (isValid == false)? 'is-invalid':''
                    ]"
                >
                    <!-- <label for="card-number-element"> {{$t('card_number')}}</label> -->
                    <div id="card-number-element" class="field form-control"></div>
                    <div id="card-number-errors" class="invalid-feedback" role="alert"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-7 p-0">
                <div class="form-group">
                    <!-- <label for="card-expiry-element"> {{$t('card_expiry')}}</label> -->
                    <div id="card-expiry-element" class="field form-control"></div>
                    <div id="card-expiry-errors" class="invalid-feedback" role="alert"></div>
                </div>
            </div>
            <div class="col-sm-5 p-0">
                <div class="form-group ml-2">
                    <!-- <label for="card-cvc-element"> {{$t('card_cvc')}}</label> -->
                    <div id="card-cvc-element" class="field form-control"></div>
                    <div id="card-cvc-errors" class="invalid-feedback" role="alert"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <!-- We'll put the error messages in this element -->
            <div id="card-element-errors" class="col-sm-12 mb-2 invalid-feedback" role="alert"></div>
        </div>
    </div>      
</template>
<script>
export default {
    name:"payment_element_card",
    data(){
        return {
            elements:null,
            stripe:null,
            cardNumber:null,
            cardExpiry:null,
            cardCvc:null,
            card_data_compleate:false,
            defaultStyles:{
                base: {
                    color: '#32325d',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#aab7c4'
                    },
                    ':focus':{
                        color: "#5c6873",
                        "background-color": "#fff",
                        "border-color": "#8ad4ee",
                        outline: 0,
                        "box-shadow": "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                    }
                },
                invalid: {
                    color: '#dc3545',
                    iconColor: '#dc3545'
                }
            },
            defaultsOptions:{
            }
        }
    },
    props:{
        instance_stripe:{
            type:Object,
        },
        public_key:{
            type:String,
        },
        cardNumberStyles:{
            type:Object
        },
        cardExpiryStyles:{
            type:Object
        },
        cardCvcStyles:{
            type:Object
        },
        isValid:{
            default:null
        },
        card:{
            type:Object
        }

        
    },
    methods:{
        initCardNumberElement(){
            let cardNumberStyles = (this.cardNumberStyles) ? this.cardNumberStyles:this.defaultStyles;
            this.cardNumber = this.elements.create('cardNumber', { style:cardNumberStyles });
            this.cardNumber.mount('#card-number-element');
            this.cardNumber.on('change', this.eventChage);
        },
        eventChage(event){
            if(!event.empty){
                if(event.error){
                    this.displayError(event);
                }else {
                    this.hideErrorsMessages(event.elementType);
                }
                if(event.complete){
                    this.$emit('update:card',this.cardNumber); 
                }  
            }else{
                this.hideErrorsMessages(event.elementType);
            }
            

        },
        initCardExpiryElement(){
            let cardExpiryStyles = (this.cardExpiryStyles) ? this.cardExpiryStyles:this.defaultStyles;
            this.cardExpiry = this.elements.create('cardExpiry', { style:cardExpiryStyles });
            this.cardExpiry.mount('#card-expiry-element');
            this.cardExpiry.on('change', this.eventChage);
        },
        initCardCvcElement(){
            let cardCvcStyles = (this.cardCvcStyles) ? this.cardCvcStyles:this.defaultStyles;
            this.cardCvc = this.elements.create('cardCvc', { style:cardCvcStyles });
            this.cardCvc.mount('#card-cvc-element');
            this.cardCvc.on('change', this.eventChage);
        },
        hideErrorsMessages(elementType){
            let displayError;
            switch (elementType) {
                case "cardNumber":
                    displayError = document.getElementById('card-number-errors');
                    break;
                case "cardCvcumber":
                    displayError = document.getElementById('card-cvc-errors');
                    break;
                case "cardExpiry":
                    displayError = document.getElementById('card-expiry-errors');
                    break;
                default:
                    displayError = document.getElementById('card-element-errors');
                    break;
                
            }
            displayError.textContent="";
        },
        displayError(event) {
            let displayError;
            switch (event.error.code) {
                case "incomplete_number":
                    displayError = document.getElementById('card-number-errors');
                    break;
                case "invalid_number":
                    displayError = document.getElementById('card-number-errors');
                    break;
                case "incomplete_expiry":
                    displayError = document.getElementById('card-expiry-errors');
                    break;
                case "incomplete_cvc":
                    displayError = document.getElementById('card-cvc-errors');
                    break;
                default:
                    displayError = document.getElementById('card-element-errors');
                    break;
            }
            // displayError = document.getElementById('card-element-errors');
            displayError.textContent = event.error.message;
        },
        
    },
    async mounted(){
        if(this.instance_stripe){
            this.stripe = this.instance_stripe;
        }
        else if(this.public_key){
            this.stripe = Stripe(this.public_key);
        }else{
            throw { code: 422, message: this.$t("I nstance stripe not found.") };
        }
        this.elements = this.stripe.elements();
        this.initCardNumberElement();
        this.initCardExpiryElement();
        this.initCardCvcElement();
    }
}
</script>

<style lang="scss" scoped>
    @import 'src/assets/scss/_variables.scss';
    @import 'node_modules/bootstrap/scss/bootstrap.scss';
    .StripeElement {
        box-sizing: border-box;

        height: 40px;

        padding: 10px 12px;

        border: 1px solid transparent;
        border-radius: 4px;
        background-color: white;

        box-shadow: 0 1px 3px 0 #e6ebf1;
        transition: box-shadow 150ms ease;
    }

    .StripeElement--focus {
        color: #5c6873;
        background-color: #fff;
        border-color: #8ad4ee;
        outline: 0;
            box-shadow: 0 0 0 0.2rem #007bff40;
    }

    .StripeElement--complete{
        @extend .is-valid;
    }

    .StripeElement--focus.StripeElement--complete{
        border-color: #28a745;
        box-shadow: 0 0 0 0.2rem #28a74540;
    }
    .StripeElement--invalid {
        @extend .is-invalid;
    }
    .StripeElement--focus.StripeElement--invalid {
        border-color: #dc3545;
        box-shadow: 0 0 0 0.2rem #dc354540;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }

    .card-element{
        min-width: 215px;
        & .card-postal-code-element{
            & :focus{
                box-shadow: none;
                border-color: none;
            }
        }

        & .invalid-feedback{
            display: block;
        }
    }
    
</style>